// -----------------------------------------------------------------------------
// Live preview of full dispatch text (must stay aligned with backend order).
// Mirrors DEFAULT_FOOTER_TEMPLATE in backend campaign-message-composer.ts
// -----------------------------------------------------------------------------

const SAMPLE_WA_ME = 'https://wa.me/5511999999999';

/** Same default body as backend when template empty / global. */
const DEFAULT_UNSUB_FOOTER_LINE =
  'Se não quiser mais receber mensagens como esta, clique no link abaixo:\n{unsubscribeUrl}';

export function renderUnsubscribeFooterPreview(template: string): string {
  const baseUrl =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : 'https://ghiconnect.com.br';
  const sampleUrl = `${baseUrl}/u/CODE`;
  const t = (template || '').trim();
  if (!t) {
    return DEFAULT_UNSUB_FOOTER_LINE.replace(/\{unsubscribeUrl\}/g, sampleUrl);
  }
  return t.includes('{unsubscribeUrl}')
    ? t.replace(/\{unsubscribeUrl\}/g, sampleUrl)
    : `${t}\n${sampleUrl}`;
}

export interface FullCampaignDispatchPreviewParams {
  mensagem: string;
  principalBlockEnabled: boolean;
  principalIntro: string;
  principalUsuarioId: string;
  useGlobalUnsubscribe: boolean;
  unsubscribeFooterTemplate: string;
}

export function buildFullCampaignDispatchPreview(p: FullCampaignDispatchPreviewParams): string {
  const body = p.mensagem.trim();
  let out = body || '(vazio)';
  if (p.principalBlockEnabled) {
    const intro = p.principalIntro.trim();
    if (intro) {
      const uid = p.principalUsuarioId.trim();
      const linkLine = uid
        ? SAMPLE_WA_ME
        : '{usePrincipalWhatsapp} (sem membro — removido no envio)';
      out += `\n\n${intro}\n${linkLine}`;
    }
  }
  const footerTemplate = p.useGlobalUnsubscribe ? '' : p.unsubscribeFooterTemplate;
  out += `\n\n${renderUnsubscribeFooterPreview(footerTemplate)}`;
  return out;
}
